export const getThemeData = () => {
	if (!window.themeDataRestUrl) {
		throw new Error('Missing themeDataRestUrl in global context');
	} else {
		const sessionStorageKey = 'themeData';
		return new Promise((resolve, reject) => {
			if (sessionStorage.getItem('themeData')) {
				resolve(JSON.parse(sessionStorage.getItem(sessionStorageKey)));
			} else {
				fetch(window.themeDataRestUrl)
					.then((res) => res.json())
					.then((data) => {
						try {
							sessionStorage.setItem(sessionStorageKey, JSON.stringify(data));
						} catch (e) {
							console.warn(e);
						}
						resolve(data);
					})
					.catch((e) => reject(e));
			}
		});
	}
};
